module.exports = __webpack_public_path__ + "static/media/sound3.5460ee9a.mp3";